<template>
  <div class="gray-back" style="height: 100%">
    <div class="score-login-box">
      <div class="score-login-logo">
        <img src="../../../assets/images/score/logo2.png" alt="">
      </div>
    </div>
    <div class="score-login-extra">
      <van-cell-group class="score-cell">
        <div v-if="startId <= 0" class="dexame-warn">
          链接无效：缺少场次参数 start_id，请使用现场提供的二维码进入。
        </div>
        <div v-else-if="sessionHint" class="dexame-session">
          <div class="dexame-session-title">{{ sessionHint }}</div>
          <div class="dexame-session-sub">输入身份证号并选择执裁项目完成本场次裁判绑定</div>
        </div>
        <van-field
          v-model="formData.id_code"
          name="身份证号"
          :left-icon="require('../../../assets/images/score/login-card.png')"
          clearable
          :readonly="readonly"
          :disabled="startId <= 0"
          placeholder="请输入身份证号"
          @focus="onFocus"
        />
        <div class="dexame-project-block" v-if="startId > 0">
          <div class="dexame-project-label">执裁项目<span class="dexame-required">（必选，可多选）</span></div>
          <van-checkbox-group v-model="formData.project">
            <van-checkbox name="花球爵士" shape="square" class="dexame-project-item">花球爵士</van-checkbox>
            <van-checkbox name="街舞" shape="square" class="dexame-project-item">街舞</van-checkbox>
            <van-checkbox name="技巧" shape="square" class="dexame-project-item">技巧</van-checkbox>
          </van-checkbox-group>
        </div>
        <div class="score-button">
          <van-button
            round
            block
            type="info"
            color="linear-gradient(to right, #72CAF9, #2492FB)"
            :disabled="startId <= 0"
            @click="onSubmit"
            v-if="!saveLoading"
          >
            接收邀请
          </van-button>
          <van-button
            round
            block
            type="info"
            color="linear-gradient(to right, #65F6D6, #0EB993)"
            v-else
          >
            提交中...
          </van-button>
        </div>
        <!-- <div v-show="formData.id_code === 'X001'" class="dexame-env-row">
          <span class="dexame-env-label">云上版</span>
          <van-switch v-model="checked" inactive-color="#eee" size="24px" @change="switchChange"/>
          <span class="dexame-env-label">内网版</span>
        </div> -->
        <div class="dexame-footer-hint">
          <!-- 考试场次裁判绑定 -->
        </div>
      </van-cell-group>
    </div>

    <van-number-keyboard
      :show="keyShow"
      extra-key="X"
      close-button-text="完成"
      v-model="formData.id_code"
      @close="keyShow = false"
    />

    <van-dialog v-model="successShow" title="绑定成功" confirm-button-text="去打分" @confirm="onBindSuccessGo">
      <div class="dexame-success-body" v-if="bindResult">
        <p>{{ bindResult.saiqu_name }} {{ bindResult.title }}</p>
        <p>{{ bindResult.name }}（{{ bindResult.caipan_type }}）</p>
        <p v-if="bindResult.already" class="dexame-muted">您已绑定过本场次</p>
      </div>
    </van-dialog>
  </div>
</template>

<style scoped>
.dexame-warn {
  color: #ee0a24;
  font-size: 14px;
  padding: 12px 16px;
  line-height: 1.5;
}

.dexame-session {
  padding: 8px 16px 4px;
}

.dexame-session-title {
  font-size: 15px;
  font-weight: 600;
  color: #323233;
  line-height: 1.4;
}

.dexame-session-sub {
  font-size: 13px;
  color: #969799;
  margin-top: 4px;
}

.dexame-project-block {
  padding: 12px 16px 8px;
}

.dexame-project-label {
  font-size: 14px;
  color: #323233;
  margin-bottom: 10px;
}

.dexame-required {
  color: #ee0a24;
  font-size: 13px;
}

.dexame-project-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-size: 15px;
}

.dexame-env-row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  gap: 10px;
}

.dexame-env-label {
  font-size: 14px;
  color: #646566;
}

.dexame-footer-hint {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #969799;
}

.dexame-success-body {
  padding: 16px 20px 8px;
  font-size: 14px;
  color: #323233;
  line-height: 1.6;
}

.dexame-muted {
  color: #969799;
  font-size: 13px;
  margin-top: 8px;
}

@media screen and (min-width: 768px) {
  .check-text {
    text-align: center;
    padding: 0.2rem;
    font-size: 16px;
    cursor: pointer;
  }
  .score-login-box {
    background: url("../../../assets/images/score/login-bg.png") no-repeat;
    background-size: 100% 1.2rem;
    height: 1.2rem;
    position: relative;
  }

  .score-login-box .score-login-logo {
    width: 1.2rem;
    height: 1.2rem;
    box-shadow: 0 1px 20px 0 rgba(28, 140, 250, 0.3);
    border-radius: 10px;
    background: #fff;
    position: absolute;
    bottom: -0.6rem;
    left: 3.15rem;
  }

  .score-login-logo img {
    width: 100%;
    height: 100%;
  }

  .score-login-extra {
    margin: 0.8rem 0;
  }

  .score-login-extra .score-cell {
    height: 1000px;
    padding: 0.5rem 0.5rem 0.8rem;
  }

  .score-login-extra >>> .van-icon__image {
    width: 0.3rem;
    height: 0.3rem;
  }

  .score-login-extra >>> .van-field__body input {
    height: 0.3rem;
    font-size: 0.2rem;
  }

  .score-login-extra .score-button {
    padding: 0.2rem 0.4rem 0;
  }
}

@media screen and (max-width: 768px) {
  .check-text {
    text-align: center;
    margin-top: 0.2rem;
    padding: 0.2rem;
    font-size: 16px;
    cursor: pointer;
  }
  .score-login-box {
    background: url("../../../assets/images/score/login-bg.png") no-repeat;
    background-size: 100% 3.8rem;
    height: 3.8rem;
    position: relative;
  }

  .score-login-box .score-login-logo {
    width: 1.6rem;
    height: 1.6rem;
    box-shadow: 0 1px 20px 0 rgba(28, 140, 250, 0.3);
    border-radius: 10px;
    background: #fff;
    position: absolute;
    bottom: -0.8rem;
    left: 2.95rem;
  }

  .score-login-extra .score-cell {
    padding: 1rem 0.5rem;
  }

  .score-login-extra .score-button {
    padding: 2rem 0.4rem 0;
  }

  .score-login-logo img {
    width: 100%;
    height: 100%;
  }

  .score-login-extra {
    margin-top: 2rem;
  }

  .score-login-extra >>> .van-icon__image {
    width: 28px;
    height: 28px;
  }

  .score-login-extra >>> .van-field__body input {
    height: 28px;
  }
}
</style>

<script>
import {
  Button,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Dialog,
  Field,
  NumberKeyboard,
  Switch,
  Toast,
} from 'vant'

export default {
  name: 'DexameLogin',
  components: {
    [Button.name]: Button,
    CellGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    Dialog,
    Field,
    [NumberKeyboard.name]: NumberKeyboard,
    Switch,
  },
  data() {
    return {
      startId: 0,
      sessionHint: '',
      saveLoading: false,
      readonly: true,
      keyShow: false,
      checked: localStorage.getItem('_is_local') == 1,
      successShow: false,
      bindResult: null,
      formData: {
        id_code: '',
        /** 执裁项目：花球爵士、街舞、技巧 */
        project: [],
      },
    }
  },
  watch: {
    keyShow(val) {
      if (val) {
        window.scrollTo(0, 50000)
      } else {
        window.scrollTo(0, 0)
      }
    },
  },
  mounted() {
    const q = this.$route.query || {}
    const sid = parseInt(q.start_id || q.startId || 0, 10)
    this.startId = sid > 0 ? sid : 0
    document.title = '考试裁判绑定'
    const num = localStorage.getItem('_id_num')
    if (num) {
      this.formData.id_code = num
    }
    if (this.startId > 0) {
      this.loadSessionTitle()
    } else {
      Toast('请使用现场二维码进入本页面')
    }
  },
  methods: {
    loadSessionTitle() {
      const that = this
      if (that.$route.query.title) {
        that.sessionHint = decodeURIComponent(String(that.$route.query.title))
        return
      }
      that.$api.post('/api/saiexame/startPublicInfo', { start_id: that.startId }, (res) => {
        const d = res.data || {}
        const head = [d.saiqu_name, d.title].filter(Boolean).join(' ')
        that.sessionHint = head || ('考试场次 #' + that.startId)
      }, () => {
        that.sessionHint = '考试场次 #' + that.startId
      }, 2)
    },
    onSubmit() {
      const that = this
      if (that.startId <= 0) {
        Toast('无效链接')
        return
      }
      if (!that.formData.id_code || !String(that.formData.id_code).trim()) {
        Toast('请输入身份证号')
        return
      }
      if (!that.formData.project || !that.formData.project.length) {
        Toast('请选择执裁项目')
        return
      }
      that.saveLoading = true
      that.$api.post('/api/saiexame/caipanSelfBind', {
        start_id: that.startId,
        id_code: String(that.formData.id_code).trim(),
        project: that.formData.project,
      }, (res) => {
        that.saveLoading = false
        const d = res.data
        that.bindResult = d
        localStorage.setItem('_id_num', d.num)
        localStorage.setItem('_exame_start_id', String(that.startId))
        that.successShow = true
        if (!d.already) {
          Toast.success('绑定成功')
        }
      }, (res) => {
        that.saveLoading = false
        Toast(res.msg || '绑定失败')
      }, 2)
    },
    onFocus() {
      if (isMobile()) {
        this.keyShow = true
      } else {
        this.readonly = false
      }
    },
    switchChange(val) {
      const value = val ? 1 : 2
      localStorage.setItem('_is_local', value)
      if (typeof appEvent === 'function') {
        appEvent({
          name: 'postMessage',
          query: { value: value }
        })
      }
    },
    onBindSuccessGo() {
      this.successShow = false
      if (typeof rbLink === 'function' && this.startId > 0) {
        rbLink({
          name: 'DexameScore',
          query: { start_id: String(this.startId) }
        })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// DexameLogin.vue?159375b6